export default {
      id: "ic_horse_race-usage",
      viewBox: "0 0 21 19",
      url: "/" + "images/icons.3.109.2.svg#ic_horse_race-usage",
      toString: function () {
        return this.url;
      }
    }